import React from 'react';
import LoaderGif from 'assets/img/loader-dots-white.gif';

export const Loader = () => (
  <div
    style={{
      textAlign: 'center',
    }}
  >
    <img width="40px" src={LoaderGif} alt="..." />
  </div>
);

export default Loader;
